export const ocupation = {
	showDetailButton: 'View More',
	hiddenDetailButton: 'View Less',
	list: [
		{
			id: 1,
			title: 'Front End Developer',
			fromTo: 'dez. 2023 – to moment',
			company: 'Arcotech',
			description: [
				{
					id: 1,
					text: `We use the Shape Up methodology for sprint planning. In most projects, we follow the
					Trunk-Based Development workflow; however, there are some exceptions where we adopt GitFlow.
					Additionally, I work with various monitoring tools, such as ArgoCD, Analytics, Grafana, and New
					Relic.`,
				},
				{
					id: 2,
					text: `In my daily work, I use React with TypeScript and Zustand for state management
					in applications. We also work with micro front-ends using module federation. For unit testing,
					we use Jest, and for the backend for frontend (BFF), we use NestJS. Our applications are hosted on
					AWS, with CloudFront as the CDN and Kubernetes for managing Docker containers.`,
				},
			],
		},
		{
			id: 2,
			title: 'Front End Developer',
			fromTo: 'may. 2021 – dez. 2023 - 2 years and 8 months',
			company: 'Zenvia',
			description: [
				{
					id: 1,
					text: `I worked using the Scrum methodology in developing new features,
					solving Bugs and testing a platform that has the objective of generating
					document design and implementation of digital journeys and chatbots`,
				},
				{
					id: 2,
					text: `During the day I used to use: NextJS + TypeScript + Redux Saga + Context API + Styled Components,
					for testing we used Cypress(e2e), Jest(unitary), we also implemented jsDocs to comment the purpose of functions,
					we applied conventional commits to keep the commits succinct, I also took care of some libs,
					From components, tokens, icons... We've used Hotjar and Google Analytics monitoring the projects`,
				},
			],
		},
		{
			id: 3,
			title: 'Front End Developer',
			fromTo: 'feb. 2021 – aug. 2021 - 7 months',
			company: 'NovaHaus',
			description: [
				{
					id: 1,
					text: `I worked with Angular on a project for Gol, using atomic design, well-css, and at the
					same time Unlike Mobile First, we created the web and then adapted it for mobile as well.
					we performed tests on other browsers to see if they behaved correctly using
					Cross Browser, Kanban was adopted to control the workflow, and the design was
					consulted through Zeplin.`,
				},
				{
					id: 2,
					text: `I participated in the development of the polyhedron's intranet, using Next with TypeScript, +
					Context to share states, docker, Material UI... And layouts were queried +
					in Figma, the design was built using grid, and to reflect this on the screen we used the +
					Grid component of the Material UI.`,
				},
			],
		},
		{
			id: 4,
			title: 'Full Stack Developer',
			fromTo: 'sep 2020 - jan 2021 - 5 months',
			company: 'NWB - Network Brazil',
			description: [
				{
					id: 1,
					text: `I developed a voting site for the Desimpedidos channel, and an interface for
								present all this data to the company.`,
				},
				{
					id: 2,
					text: `I participated in the development of Xtrala(EJS/ React Native) a platform that brings
					fans/talents, where the user can buy videos of the desired talent, I also did the
					application to list talent requests, show the statement, record and send the
					videos for the user.`,
				},
				{
					id: 3,
					text: `I developed updates on the company's website using Angular, creating new screens and
					improving the old, I also started to insert an accounting system.`,
				},
			],
		},
	],
};
